import { FC } from 'react';

import { useHistoryMovementsView } from '../context/HistoryMovementsViewContext';
import { historyMovementsViewExpandedTableBodyMap } from '../constants/historyMovementsViewExpandedTableBodyMap';

const HistoryMovementsViewExpandedTableBody: FC = () => {
  const { data } = useHistoryMovementsView();

  const BodyComponent =
    data.operationType &&
    historyMovementsViewExpandedTableBodyMap[data.operationType];

  return (BodyComponent && <BodyComponent />) || null;
};

export default HistoryMovementsViewExpandedTableBody;
